import { get } from "../../service/api";

const GetProductTypes = async () => {
    try {
        const response = await get(`/reference/productType`);
        return response.data;
    } catch (error) {
        console.error('Error GetProductTypes:', error);
        throw error;
    }
};

export default GetProductTypes;